module.exports = __webpack_public_path__ + "img/twitter.6d46f97f.svg";